<div class="display-flex justify-content-space-between align-items-center">
  <audio sbBlobPlayer [src]="message.voice_message.url"></audio>

  <button
    sbButton
    [iconOnly]="true"
    [size]="'medium'"
    [variant]="theme === 'light' ? 'fill-light' : 'fill-void'"
    (click)="togglePlayPause()"
  >
    <sb-icon
      [name]="player().playing() ? 'pause-2' : 'play-circle'"
      [ngClass]="theme === 'light' ? 'color-blue' : 'color-white'"
    />
  </button>

  <sb-voice-message-progress-bar class="mh-2" [progress]="progress()" [theme]="theme" />

  <div class="t-8@r font-weight-500" [ngClass]="theme === 'light' ? 'color-white' : 'color-jet'">
    {{ timer() | date: 'm:ss' }}
  </div>
</div>
